// componentMappings.js
import Error404 from "../Components/Error404";
import Roles from "../Pages/Roles";
import LoginLogs from "../Pages/AuditLogs/LoginLogs";
import LogoutLogs from "../Pages/AuditLogs/LogoutLogs";
import ActionLogs from "../Pages/AuditLogs/ActionLogs";
import LoginFailedLogs from "../Pages/AuditLogs/LoginFailedLogs";

// SSSAuto imports
import Area from "../Pages/SSSAuto/Area";
import AreaMaster from "../Pages/SSSAuto/AreaMaster";
import InBramst from "../Pages/SSSAuto/InBramst";
import InMaster from "../Pages/SSSAuto/InMaster";
import SalesMan from "../Pages/SSSAuto/SalesMan";
import BinBayLocation from "../Pages/SSSAuto/BinBayLocation";
import BinBayLive from "../Pages/SSSAuto/BinBayLive";
import FakeCustomer from "../Pages/SSSAuto/FakeCustomer";
import CustomNotification from "../Pages/SSSAuto/CustomNotification";
import HoldReason from "../Pages/SSSAuto/HoldReason";

// Supervisor imports
import SupervisorDashboard from "../Pages/SSSAuto/Supervisor/Dashboard/Dashboard";
import SupervisorAllOrders from "../Pages/SSSAuto/Supervisor/orders/AllOrders";
import SupervisorOrdersOnHold from "../Pages/SSSAuto/Supervisor/orders/OnHold";
import SupervisorCompletedOrders from "../Pages/SSSAuto/Supervisor/orders/Completed";

// SuperAdmin imports
import SuperAdminDashboard from "../Pages/SSSAuto/SuperAdmin/dashboard/Dashboard";
import AllOrder from "../Pages/SSSAuto/SuperAdmin/orders/AllOrders";
import DelayPickingOrder from "../Pages/SSSAuto/SuperAdmin/orders/DelayPickingOrder";
import OrderOnHold from "../Pages/SSSAuto/SuperAdmin/orders/OnHold";
import InQueue from "../Pages/SSSAuto/SuperAdmin/orders/InQueue";
import InProgress from "../Pages/SSSAuto/SuperAdmin/orders/InProgress";
import CompletedOrder from "../Pages/SSSAuto/SuperAdmin/orders/Completed";
import CanceledOrder from "../Pages/SSSAuto/SuperAdmin/orders/Canceled";
import GitOrder from "../Pages/SSSAuto/SuperAdmin/orders/GitOrder";
import FakeCustomerOrder from "../Pages/SSSAuto/SuperAdmin/orders/FakeCustomer";
import Stocks from "../Pages/SSSAuto/SuperAdmin/stocks/Stocks";
import UserAll from "../Pages/SSSAuto/SuperAdmin/users/AllUsers";
import UserAdmin from "../Pages/SSSAuto/SuperAdmin/users/SuperAdmins";
import UserSupervisor from "../Pages/SSSAuto/SuperAdmin/users/Supervisors";
import UserManager from "../Pages/SSSAuto/SuperAdmin/users/Managers";
import UserPicker from "../Pages/SSSAuto/SuperAdmin/users/Pickers";
import UserPacker from "../Pages/SSSAuto/SuperAdmin/users/Packers";
import UserList from "../Pages/SSSAuto/SuperAdmin/users/UserList";
import AllDevice from "../Pages/SSSAuto/SuperAdmin/devices/AllDevices";
import AssignedDevice from "../Pages/SSSAuto/SuperAdmin/devices/Assigned";
import UnassignedDevice from "../Pages/SSSAuto/SuperAdmin/devices/Unassigned";
import ArchivedDevice from "../Pages/SSSAuto/SuperAdmin/devices/Archived";
import PickerEfficiency from "../Pages/SSSAuto/SuperAdmin/reports/picker-efficiency/PickerEfficiency";
import OrderEfficiency from "../Pages/SSSAuto/SuperAdmin/reports/order-efficiency/OrderEfficiency";
import BayReport from "../Pages/SSSAuto/SuperAdmin/reports/bay-report";
import PickerReport from "../Pages/SSSAuto/SuperAdmin/reports/picker-report";
import BreakReport from "../Pages/SSSAuto/SuperAdmin/reports/break-report";
import Drivers from "../Pages/SSSAuto/Delivery/Drivers";
import DeliveryOrders from "../Pages/SSSAuto/Delivery/Orders";
import TrackOrder from "../Pages/SSSAuto/Delivery/TrackOrder";
import DriversReport from "../Pages/SSSAuto/Delivery/Report/DriversReport";
import CurrentDriversReport from "../Pages/SSSAuto/Delivery/Report/CurrentDriverReport";
import DeliveryReasons from "../Pages/SSSAuto/Delivery/Reasons";
import RegionalFreight from "../Pages/SSSAuto/RegionalFreight";
import DeliveryTruckSchedule from "../Pages/SSSAuto/DeliveryTruckSchedule";
import BayPullingSchedule from "../Pages/SSSAuto/BayPullingSchedule";
import BreakReason from "../Pages/SSSAuto/BreakReason";
import Depot from "../Pages/SSSAuto/Delivery/Depot";
import Permission from "../Pages/Permission";
import MasterSetting from "../Pages/SSSAuto/MasterSetting";
// Main component mapping for top-level menu items
export const componentMapping = {
  Users: Error404,
  Roles: Roles,
  Permission : Permission,
  AuditLogs: Error404,
  SSSAuto: Error404,
  Supervisor: Error404,
  SuperAdmin: Error404,
  Devices: AllDevice,
  Orders: Error404,
  BinBayLocation: BinBayLocation,
  BinBay: BinBayLive,
  FakeCustomer: FakeCustomer,
  CustomNotification: CustomNotification,
  RegionalFreight: RegionalFreight,
  DeliveryTruckSchedule:DeliveryTruckSchedule,
  BayPullingSchedule:BayPullingSchedule,
  BreakReason : BreakReason,
  HoldReason: HoldReason,
  Report: Error404,
  Delivery: Error404,
};

// SSSAuto specific components
export const sssAutoComponentMapping = {
  Area: Area,
  ArMaster: AreaMaster,
  InBramst: InBramst,
  InMaster: InMaster,
  SalesMan: SalesMan,
  LoginLogs: LoginLogs,
  LogoutLogs: LogoutLogs,
  ActionLogs: ActionLogs,
  LoginFailedLogs: LoginFailedLogs,
  Drivers: Drivers,
  Orders: DeliveryOrders,
  OrdersStatus: TrackOrder,
  DriversReport: DriversReport,
  CurrentDriversReport: CurrentDriversReport,
  OrderDeliveryReason: DeliveryReasons,
  DeliveryDepo: Depot,
  MasterSetting: MasterSetting,
};

// Supervisor specific components
export const supervisorComponentMapping = {
  Dashboard: SupervisorDashboard,
  SupervisorOrders: Error404,
  SupervisorAllOrders: SupervisorAllOrders,
  SupervisorOrdersOnHold: SupervisorOrdersOnHold,
  SupervisorCompletedOrders: SupervisorCompletedOrders,
};

// SuperAdmin specific components
export const superAdminComponentMapping = {
  SuperAdminDashboard: SuperAdminDashboard,
  SuperAdminOrders: Error404,
  AllOrder: AllOrder,
  DelayPickingOrder: DelayPickingOrder,
  GitOrder: GitOrder,
  OrderOnHold: OrderOnHold,
  InQueue: InQueue,
  InProgress: InProgress,
  CompletedOrder: CompletedOrder,
  CanceledOrder: CanceledOrder,
  FakeCustomerOrder: FakeCustomerOrder,
  Stocks: Stocks,
  SuperAdminUsers: Error404,
  UserAll: UserAll,
  UserAdmin: UserAdmin,
  UserManager: UserManager,
  UserSupervisor: UserSupervisor,
  UserPicker: UserPicker,
  UserPacker: UserPacker,
  UserList: UserList,
  SuperAdminDevices: Error404,
  AllDevice: AllDevice,
  AssignedDevice: AssignedDevice,
  UnassignedDevice: UnassignedDevice,
  ArchivedDevice: ArchivedDevice,
  Reports: Error404,
  OrderEfficiency: OrderEfficiency,
  PickerEfficiency: PickerEfficiency,
  BayReport: BayReport,
  PickerReport: PickerReport,
  BreakReport: BreakReport,
};
